import React from "react";

// Neon yellow-green angular triangle/arrow accents — USG signature shape
// Renders one or more polygons positioned over imagery.
export function GeoAccents({
  className = "",
  color = "var(--csg-accent)",
  colors = null,
  opacity = 0.9,
}) {
  // If colors array provided, use them per-polygon (max 3); else fall back to single color
  const c1 = colors && colors[0] ? colors[0] : color;
  const c2 = colors && colors[1] ? colors[1] : color;
  const c3 = colors && colors[2] ? colors[2] : (colors && colors[0]) || color;
  return (
    <svg
      viewBox="0 0 600 600"
      className={`absolute pointer-events-none ${className}`}
      aria-hidden
    >
      <g opacity={opacity}>
        <polygon points="40,60 240,40 80,260" fill={c1} />
        <polygon points="520,420 580,560 380,520" fill={c2} />
        <polygon points="320,150 410,200 350,250" fill={c3} opacity="0.7" />
      </g>
    </svg>
  );
}

// Thin zigzag divider stroke (top edge of black sections, USG-style).
export function ZigzagDivider({
  color = "var(--csg-accent)",
  className = "",
  height = 22,
}) {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 1440 30"
      className={`block w-full ${className}`}
      style={{ height }}
      aria-hidden
    >
      <polyline
        points="0,30 240,2 480,30 720,2 960,30 1200,2 1440,30"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="miter"
      />
    </svg>
  );
}

// Inverse zigzag — bottom edge that dips into the section below.
export function ZigzagDividerInverse({
  color = "var(--csg-accent)",
  className = "",
  height = 22,
}) {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 1440 30"
      className={`block w-full ${className}`}
      style={{ height }}
      aria-hidden
    >
      <polyline
        points="0,0 240,28 480,0 720,28 960,0 1200,28 1440,0"
        fill="none"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
